// The server accepts at most 700,000 BASE64 characters, not 700 KB of binary.
// Check the encoded result so both employee upload screens obey that contract.
const MAX_BASE64_LENGTH = 700_000;
export const EMPLOYEE_PHOTO_CHANGED = "epplehub:employee-photo-changed";

export function notifyEmployeePhotoChanged(employeeId) {
  window.dispatchEvent(new CustomEvent(EMPLOYEE_PHOTO_CHANGED, { detail: { employeeId } }));
}

export async function prepareEmployeePhoto(file, crop = null) {
  if (!file || (file.type && !file.type.startsWith("image/"))) {
    throw new Error("Pilih berkas foto JPG, PNG, atau WebP.");
  }
  const sourceUrl = URL.createObjectURL(file);
  const canvas = document.createElement("canvas");
  try {
    const img = await new Promise((resolve, reject) => {
      const picture = new Image();
      picture.onload = () => resolve(picture);
      picture.onerror = () => reject(new Error("Foto tidak dapat dibaca. Coba simpan sebagai JPG, PNG, atau WebP lalu unggah kembali."));
      picture.src = sourceUrl;
    });
    const source = crop ? { x: crop.x, y: crop.y, width: crop.size, height: crop.size } : { x: 0, y: 0, width: img.naturalWidth, height: img.naturalHeight };
    if (!Object.values(source).every(Number.isFinite) || source.width <= 0 || source.height <= 0 || source.x < 0 || source.y < 0 || source.x + source.width > img.naturalWidth + 0.01 || source.y + source.height > img.naturalHeight + 0.01) throw new Error("Posisi foto tidak valid. Atur ulang potongan foto.");
    const scale = Math.min(1, 1024 / Math.max(source.width, source.height));
    let width = Math.max(1, Math.round(source.width * scale));
    let height = Math.max(1, Math.round(source.height * scale));
    const context = canvas.getContext("2d");
    if (!context) throw new Error("Browser tidak dapat memproses foto. Coba gunakan browser lain.");

    // Preserve proportions, never enlarge small images, and flatten transparent
    // backgrounds to white before JPEG encoding. Reduce dimensions only if needed.
    for (let step = 0; step < 5; step++) {
      canvas.width = width;
      canvas.height = height;
      context.fillStyle = "#fff";
      context.fillRect(0, 0, width, height);
      context.drawImage(img, source.x, source.y, source.width, source.height, 0, 0, width, height);
      for (const quality of [0.9, 0.8, 0.7, 0.6]) {
        const blob = await new Promise(resolve => canvas.toBlob(resolve, "image/jpeg", quality));
        if (!blob) throw new Error("Foto gagal dikompres. Coba pilih foto lain.");
        if (Math.ceil(blob.size / 3) * 4 > MAX_BASE64_LENGTH) continue;
        const content = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = () => reject(new Error("Foto gagal dibaca setelah dikompres."));
          reader.readAsDataURL(blob);
        });
        return { content_base64: content, bytes: blob.size, originalBytes: file.size, width, height };
      }
      width = Math.max(1, Math.round(width * 0.75));
      height = Math.max(1, Math.round(height * 0.75));
    }
    throw new Error("Foto belum dapat diperkecil sesuai batas upload. Coba pilih foto lain.");
  } finally {
    URL.revokeObjectURL(sourceUrl);
    canvas.width = canvas.height = 0;
  }
}
